// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1ajPH","content":"styles_content__2TmjM","checkbox":"styles_checkbox__36Xdm","checkboxLabel":"styles_checkboxLabel__wuWlZ"};